import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
//
import App from './App';

// ----------------------------------------------------------------------

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="*"
      element={
        <Suspense>
          <App />
        </Suspense>
      }
    />
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <RouterProvider router={router} />
  </HelmetProvider>
);
